import script from "./MessagesListSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesListSection.vue?vue&type=script&setup=true&lang=js"

import "./MessagesListSection.vue?vue&type=style&index=0&id=4c0e91d0&lang=css"

const __exports__ = script;

export default __exports__